import React from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import AlertBox from 'components/ui/AlertBox';
import { serviceStatuses } from 'types/timetableServices';

import { shouldShowTrainSwapAlert } from './utils';

const TrainSwapWarning = ({ timetableServices }) => {
  const showAlert = shouldShowTrainSwapAlert({ timetableServices });

  if (!showAlert) {
    return null;
  }

  return (
    <AlertBox variant={AlertBox.variants.WARNING}>
      <FormattedMessage id="journeySegment.trainSwapWarning" />
    </AlertBox>
  );
};

TrainSwapWarning.propTypes = {
  timetableServices: PropTypes.arrayOf(
    PropTypes.shape({
      model: PropTypes.shape({
        serviceStatus: PropTypes.oneOf(Object.keys(serviceStatuses))
      })
    })
  )
};

export default injectIntl(TrainSwapWarning);
